import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=67b2b1c8"
import script from "./Checkbox.vue?vue&type=script&lang=ts"
export * from "./Checkbox.vue?vue&type=script&lang=ts"
import style0 from "./Checkbox.vue?vue&type=style&index=0&id=67b2b1c8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports